export const filter = {
    id: "",
    name: "",
    is_active: "",
    search: "",
    created_at: "",
    updated_at: "",
};
